/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAdministrativesRequestPayloadExportCsv } from '../../models/get-administratives-request-payload-export-csv';

export interface PostApiAdministrativeV1Export$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload containing filter options for export.
     */
    body?: GetAdministrativesRequestPayloadExportCsv
}

export function postApiAdministrativeV1Export$Json(http: HttpClient, rootUrl: string, params?: PostApiAdministrativeV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, postApiAdministrativeV1Export$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

postApiAdministrativeV1Export$Json.PATH = '/private/v1/companies/export';
